import { IconArrowDownLeft, IconArrowUpRight, IconFileUnknown } from '@tabler/icons-react';
import { Group, Text, ThemeIcon } from '@mantine/core';
import { useI18n } from '@/shared/i18n';
import {
  isIncomingSyrveDocumentType,
  isOutgoingSyrveDocumentType,
} from '@/shared/syrve/syrveDocumentTypeUi';

export function SyrveDocumentTypeBadge({ documentType }: { documentType: string }) {
  const { t } = useI18n();

  if (isIncomingSyrveDocumentType(documentType)) {
    return (
      <Group gap={6} wrap="nowrap" align="center" data-testid="syrve-doc-type-incoming">
        <ThemeIcon size={22} radius="xl" variant="light" color="teal" aria-hidden>
          <IconArrowDownLeft size={13} stroke={2} />
        </ThemeIcon>
        <Text size="xs" fw={600} lh={1.2}>
          {t('syrve.documents.type.incoming')}
        </Text>
      </Group>
    );
  }

  if (isOutgoingSyrveDocumentType(documentType)) {
    return (
      <Group gap={6} wrap="nowrap" align="center" data-testid="syrve-doc-type-outgoing">
        <ThemeIcon size={22} radius="xl" variant="light" color="orange" aria-hidden>
          <IconArrowUpRight size={13} stroke={2} />
        </ThemeIcon>
        <Text size="xs" fw={600} lh={1.2}>
          {t('syrve.documents.type.outgoing')}
        </Text>
      </Group>
    );
  }

  return (
    <Group gap={6} wrap="nowrap" align="center">
      <ThemeIcon size={22} radius="xl" variant="light" color="gray" aria-hidden>
        <IconFileUnknown size={13} stroke={2} />
      </ThemeIcon>
      <Text size="xs" c="dimmed" lh={1.2}>
        {documentType}
      </Text>
    </Group>
  );
}
